var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditDisable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_917_1646)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#E5E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "#DDDBDB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2938 7.87873H9.13058C8.76099 7.85781 8.01761 8.01263 8.00087 8.79924V15.8076C7.98693 16.1842 8.13476 16.9499 8.83769 17.0001H15.9925C16.2994 16.9792 16.9298 16.749 16.9967 15.9959V11.8118",
    stroke: "#C2C2C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1973 14.6151L10.5948 12.4603L16.2224 7C17.7621 7.26778 17.9239 8.4226 17.8123 8.96653L12.4567 14.2804L10.1973 14.6151Z",
    stroke: "#C2C2C2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_917_1646",
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.758333 0 0 0 0 0.758333 0 0 0 0 0.758333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_917_1646"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_917_1646",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDisable);
export default __webpack_public_path__ + "static/media/edit-disable.6c0bd8978e376b41cb27baaf48d5d15e.svg";
export { ForwardRef as ReactComponent };